import { render } from "./Curriculum.vue?vue&type=template&id=5e73e135&scoped=true"
import script from "./Curriculum.vue?vue&type=script&lang=js"
export * from "./Curriculum.vue?vue&type=script&lang=js"

import "./Curriculum.vue?vue&type=style&index=0&id=5e73e135&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e73e135"]])

export default __exports__